import { createMuiTheme } from '@material-ui/core/styles';
const checkitTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#55baa1',
            contrastText: '#ffffff'
        },
        secondary: {
            main: '#e54a36'
        },
        error: {
            main: '#e54a36'
        },
        text: {
            disabled: '#aaaaaa',
            primary: '#444444'
        },
        action: {
            disabled: '#BFBFBF'
        }
    }
});
export default checkitTheme;
//# sourceMappingURL=checkit-theme.js.map